import { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPersonCircleQuestion,
  faEarthAmericas,
} from "@fortawesome/free-solid-svg-icons";
import CustomHook from "./CustomHook";
import ym from "react-yandex-metrika";

// images of projects

function Projects() {
  const [listProjects] = useState([
    {
      deployLink: "https://domotprofi.ru/projection.html",
      gitHubLinkClient: "",
      name: "ДомОтПрофи",
      des: "",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/domotprofi.png",
      mission: "Главная страница сайта домотпрофи",
      language: "HTML, CSS, JavaScript, PHP",
      images: "https://ygamijs.github.io/YgamiJS/src/img/domotprofipage.webp",
      secondButton: false,
    },
    {
      deployLink: "https://ygamijs.github.io/Gremlins/",
      gitHubLinkClient: "",
      name: "Gremlins",
      des: "",
      mission: "Студия разработки игр",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/gremlins_10_11zon.png",
      language: "HTML, CSS, JavaScript, Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/Gremlins.webp",
      secondButton: true,
    },

    {
      deployLink: "https://ygamijs.github.io/zaitsev/",
      gitHubLinkClient: "",
      name: "WEB Zaitsev",
      des: "",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/zaitsev_9_11zon.png",
      mission: "Zaitsev личный веб-сайт",
      language: "HTML, CSS, JavaScript, Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/zaitsev.webp",
      secondButton: false,
    },

    {
      deployLink: "https://baker-brands.vercel.app/",
      gitHubLinkClient: "",
      name: "BakerBrands",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/bakerbrands_8_11zon.png",
      des: "",
      mission: "Интернет магазин одежды",
      language: "Vue, Pinia, TypeScript, Firebase, SCSS, Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/Bakerbrands.webp",
      secondButton: true,
    },

    {
      deployLink: "https://ygamijs.github.io/phoenix-hr/",
      gitHubLinkClient: "",
      name: "Phoenix HR",
      des: "",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/phoenix.png",
      mission: "Агенство подбора персонала",
      language: "PHP, WordPress, HTML, CSS, JavaScript",
      images: "https://ygamijs.github.io/YgamiJS/src/img/Phoenixhr.webp",
      secondButton: true,
    },

    {
      deployLink: "https://ygamijs.github.io/Yoga/",
      gitHubLinkClient: "",
      name: "Yoga",
      des: "",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/yoganew.png",
      mission: "Лэндинг услуг йоги",
      language: "HTML, SCSS, JavaScript, Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/Yoga.webp",
      secondButton: true,
    },

    {
      deployLink: "https://ygamijs.github.io/elanburger/",
      gitHubLinkClient: "",
      name: "ЭЛАН Бургерная",
      des: "",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/elanburgernew.png",
      mission: "Заведение фастфуда",
      language: "HTML, SCSS, JavaScript, Boostrap 5, Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/ElanBurgers.webp",
      secondButton: true,
    },

    {
      deployLink: "https://ygamijs.github.io/CVRecruitment/",
      gitHubLinkClient: "",
      name: "CVRecruitment",
      des: "",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/cvrecruitment_4_11zon.png",
      mission: "Агенство подбора персонала",
      language: "HTML, SCSS, TypeScript, Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/CVRecruitment.webp",
      secondButton: true,
    },

    // {
    //   deployLink: "https://ygamijs.github.io/zaitsev/",
    //   gitHubLinkClient: "",
    //   name: "WEB Zaitsev",
    //   des: "",
    //   mission: "Zaitsev личный веб-сайт",
    //   language: "HTML, CSS, JavaScript, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/zaitsev.webp",
    //   secondButton: false,
    // },

    // {
    //   deployLink: "https://ygamijs.github.io/Gremlins/",
    //   gitHubLinkClient: "",
    //   name: "Gremlins",
    //   des: "",
    //   mission: "Студия разработки игр ",
    //   language: "HTML, CSS, JavaScript, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/Gremlins.webp",
    //   secondButton: true,
    // },

    // {
    //   deployLink: "https://baker-brands.netlify.app/",
    //   gitHubLinkClient: "",
    //   name: "BakerBrands",
    //   des: "",
    //   mission: "Интернет магазин одежды",
    //   language: "Vue, Pinia, TypeScript, Firebase, SCSS, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/Bakerbrands.webp",
    //   secondButton: true,
    // },

    // {
    //   deployLink: "https://phoenix-hr.ru",
    //   gitHubLinkClient: "",
    //   name: "Phoenix HR",
    //   des: "",
    //   mission: "Агенство подбора персонала",
    //   language: "PHP, WordPress, HTML, CSS, JavaScript",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/Phoenixhr.webp",
    //   secondButton: true,
    // },

    // {
    //   deployLink: "https://safeplace-olgamarley.ru/",
    //   gitHubLinkClient: "",
    //   name: "Yoga",
    //   des: "",
    //   mission: "Лэндинг услуг йоги",
    //   language: "HTML, SCSS, JavaScript, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/Yoga.webp",
    //   secondButton: true,
    // },

    {
      deployLink: "https://ygamijs.github.io/Nike-Shoes/",
      gitHubLinkClient: "",
      name: "Nike Shoes",
      des: "",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/nike_3_11zon.png",
      mission: "Лэндинг магазина обуви",
      language: "HTML, SCSS, JavaScript, Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/NikeShoes.webp",
      secondButton: true,
    },

    {
      deployLink: "https://ygamijs.github.io/Fitness/",
      gitHubLinkClient: "",
      name: "Fitness",
      des: "",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/fitnessnew.png",
      mission: "Сайт фитнес центра",
      language: "HTML, SCSS, JavaScript, Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/fitness.webp",
      secondButton: true,
    },

    {
      deployLink: "https://ygamijs.github.io/Plant/",
      gitHubLinkClient: "",
      name: "Plant",
      des: "",
      macbook: true,
      macbook_src:
        "https://ygamijs.github.io/YgamiJS/src/img/mackbook/plant_1_11zon.png",
      mission: "Сайт продажи растений",
      language: "HTML, SCSS, JavaScript, Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/Plant.webp",
      secondButton: true,
    },

    // {
    //   deployLink: "https://elanburgers.ru/",
    //   gitHubLinkClient: "",
    //   name: "ЭЛАН Бургерная",
    //   des: "",
    //   mission: "Заведение фастфуда",
    //   language: "HTML, SCSS, JavaScript, Boostrap 5, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/ElanBurgers.webp",
    //   secondButton: true,
    // },

    {
      deployLink: "",
      gitHubLinkClient: "",
      name: "StockRoom",
      des: "",
      mission: "Страница Авторизации StockRoom",
      language: "HTML, CSS, TypeScript, Vue, Vee-valiadate , Pinia",
      images: "https://ygamijs.github.io/YgamiJS/src/img/auth_stockroom.webp",
      secondButton: false,
    },

    {
      deployLink: "",
      gitHubLinkClient: "",
      name: "Страница Регистрации",
      des: "",
      mission: "Страница Регистрации StockRoom",
      language: "HTML, CSS, TypeScript, Vue, Vee-valiadate , Pinia",
      images:
        "https://ygamijs.github.io/YgamiJS/src/img/auth_registration.webp",
      secondButton: false,
    },

    {
      deployLink: "",
      gitHubLinkClient: "",
      name: "StockRoom",
      des: "",
      mission: "Сайт администратирования ЖК",
      language: "HTML, SCSS, Vue , Pinia, TypeScript , Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/stockroom1.webp",
      secondButton: true,
    },

    {
      deployLink: "",
      gitHubLinkClient: "",
      name: "StockRoom",
      des: "",
      mission: "Сайт администратирования ЖК",
      language: "HTML, SCSS, Vue , Pinia, TypeScript , Vite",
      images: "https://ygamijs.github.io/YgamiJS/src/img/stockroom2.webp",
      secondButton: true,
    },

    {
      deployLink: "https://domotprofi.ru/projection.html",
      gitHubLinkClient: "",
      name: "ДомОтПрофи",
      des: "",
      mission: "Страница проектирования компании домотпрофи",
      language: "HTML, CSS, JavaScript, PHP",
      images: "https://ygamijs.github.io/YgamiJS/src/img/dom1.jpg",
      secondButton: false,
    },

    {
      deployLink: "https://domotprofi.ru/certificates",
      gitHubLinkClient: "",
      name: "DomOtProfi",
      des: "",
      mission: "Сертификаты и партнеры ДомОтПрофи",
      language: "HTML, CSS, JavaScript, PHP, Swiper",
      images: "https://ygamijs.github.io/YgamiJS/src/img/domotprofi_8.webp",
      secondButton: false,
    },

    {
      deployLink: "https://domotprofi.ru/akcii.html",
      gitHubLinkClient: "",
      name: "DomOtProfi",
      des: "",
      mission: "Страница акций компании домотпрофи",
      language: "HTML, CSS, JavaScript, PHP",
      images: "https://ygamijs.github.io/YgamiJS/src/img/dom6_6_11zon.webp",
      secondButton: false,
    },

    {
      deployLink: "https://domotprofi.ru/configuration-and-prices.html",
      gitHubLinkClient: "",
      name: "DomOtProfi",
      des: "",
      mission: "Страница комлектаций домов компании домотпрофи",
      language: "HTML, CSS, JavaScript, PHP",
      images: "https://ygamijs.github.io/YgamiJS/src/img/dom3_3_11zon.webp",
      secondButton: false,
    },

    {
      deployLink: "https://domotprofi.ru/vacancies.html",
      gitHubLinkClient: "",
      name: "DomOtProfi",
      des: "",
      mission: "Страница вакансий компании домотпрофи",
      language: "HTML, CSS, JavaScript, PHP",
      images: "https://ygamijs.github.io/YgamiJS/src/img/dom4_4_11zon.webp",
      secondButton: false,
    },

    {
      deployLink: "https://domotprofi.ru/requisite.html",
      gitHubLinkClient: "",
      name: "DomOtProfi",
      des: "",
      mission: "Страница реквизитов компании домотпрофи",
      language: "HTML, CSS, JavaScript, PHP",
      images: "https://ygamijs.github.io/YgamiJS/src/img/dom5_5_11zon.webp",
      secondButton: false,
    },

    {
      deployLink: "https://domotprofi.ru/about/faq",
      gitHubLinkClient: "",
      name: "DomOtProfi",
      des: "",
      mission: "Страница часто задаваемых вопросов компании домотпрофи",
      language: "HTML, CSS, JavaScript, PHP",
      images: "https://ygamijs.github.io/YgamiJS/src/img/dom2_2_11zon.webp",
      secondButton: false,
    },

    // {
    //   deployLink: "https://ygamijs.github.io/CVRecruitment/",
    //   gitHubLinkClient: "",
    //   name: "CVRecruitment",
    //   des: "",
    //   mission: "Агенство подбора персонала",
    //   language: "HTML, SCSS, TypeScript, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/CVRecruitment.webp",
    //   secondButton: true,
    // },

    // {
    //   deployLink: "https://ygamijs.github.io/Slotgames/",
    //   gitHubLinkClient: "",
    //   name: "Slotgames",
    //   des: "",
    //   mission: "Сайт игр",
    //   language: "HTML, SCSS, JavaScript, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/Topvgames.webp",
    //   secondButton: true,
    // },

    // {
    //   deployLink: "https://cimogames.xyz",
    //   gitHubLinkClient: "",
    //   name: "Cimogames",
    //   des: "",
    //   mission: "Сайт игр",
    //   language: "HTML, SCSS, JavaScript, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/Comigames.webp",
    //   secondButton: true,
    // },

    {
      deployLink: "https://domotprofi.ru/contacts",
      gitHubLinkClient: "",
      name: "DomOtProfi",
      des: "",
      mission: "Страница контактов компании домотпрофи",
      language: "HTML, CSS, JavaScript, PHP",
      images: "https://ygamijs.github.io/YgamiJS/src/img/dom7_7_11zon.webp",
      secondButton: false,
    },

    // {
    //   deployLink: "https://ygamijs.github.io/Virtualgames/",
    //   gitHubLinkClient: "",
    //   name: "Virtualgames",
    //   des: "",
    //   mission: "Сайт игр",
    //   language: "HTML, SCSS, JavaScript, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/Virtualgames.webp",
    //   secondButton: true,
    // },
    // {
    //   deployLink: "https://ygamijs.github.io/Interior",
    //   gitHubLinkClient: "",
    //   name: "Interior",
    //   des: "",
    //   mission: "Интернет магазин мебели",
    //   language: "HTML, SCSS, React, Redux, Vite",
    //   images: "https://ygamijs.github.io/YgamiJS/src/img/Interior.webp",
    //   secondButton: true,
    // },
  ]);
  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);

  const goToLink = (url) => {
    ym("reachGoal", "check_project");

    window.open(url, "_blank");
  };

  return (
    <section className="projects" ref={scrollTab} id="projects">
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        Проекты
      </div>
      <div className="des" ref={(el) => el && divs.current.push(el)}></div>
      <div className="list">
        {listProjects.map((value, key) => (
          <div
            className="item"
            key={key}
            ref={(el) => el && divs.current.push(el)}
          >
            <div className="images">
              {key == 0 ? (
                <img
                  id={`img${key}`}
                  className={`lightbox group ${
                    value.macbook ? "img-decor" : ""
                  }`}
                  data-gallery="multiimages"
                  data-fancybox="multiimages"
                  data-caption={value.name}
                  data-src={
                    value.macbook_src ? value.images : value.macbook_src
                  }
                  src={value.macbook_src || value.images}
                  alt=""
                />
              ) : (
                <img
                  id={`img${key}`}
                  className={`lightbox group ${
                    value.macbook ? "img-decor" : ""
                  }`}
                  data-gallery="multiimages"
                  data-fancybox="multiimages"
                  data-caption={value.name}
                  data-src={
                    value.macbook_src ? value.images : value.macbook_src
                  }
                  src={value.macbook_src || value.images}
                  alt=""
                  fetchpriority="low"
                  loading="lazy"
                />
              )}
            </div>
            <div className="content">
              <h3>{value.name}</h3>
              <div className="des">{value.des}</div>
              <div className="mission">
                <div>
                  <FontAwesomeIcon icon={faPersonCircleQuestion} />
                </div>
                <div>
                  <h4>Описание</h4>
                  <div className="des">{value.mission}</div>
                </div>
              </div>
              <div className="mission">
                <div>
                  <FontAwesomeIcon icon={faEarthAmericas} />
                </div>
                <div>
                  <h4>Технологии</h4>
                  <div className="des">{value.language}</div>
                </div>
              </div>
              <div className="buttons-section">
                {value.deployLink && (
                  <button
                    onClick={() => goToLink(value.deployLink)}
                    className="glowbutton"
                  >
                    Перейти
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
export default Projects;
